export enum EMAIL_SETTING_TYPE {
    ORDER = 5,
    SYSTEM = 6
 }